module.exports = __webpack_public_path__ + "static/media/search-light.43ab9004.svg";